import { render, staticRenderFns } from "./VerifySlide.vue?vue&type=template&id=36290cd2"
import script from "./VerifySlide.vue?vue&type=script&lang=js"
export * from "./VerifySlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports